/**
 * [redux middleware for x-api analytics]
 * @param {function} getStatementByActionType A function that returns a statement
 * object for selected action type
 * @return {object}
 */

const STATEMENTS_URL = 'api/statements';

export function xApiAnalyticsNew(getStatementByActionType) {
    return ({ getState }) => next => action => {
        if (!action.type || !getStatementByActionType) {
            return next(action);
        }
        const state = getState();

        const statements = getStatementByActionType(action, state);

        if (statements) {
            const statementsArray = Array.isArray(statements) ? statements : [statements];

            statementsArray.forEach(statementObj => {
                fetch(`/${STATEMENTS_URL}/classroom`, {
                    method: 'POST',
                    credentials: 'include',
                    body: JSON.stringify(statementObj)
                });
            });
        }

        return next(action);
    };
}
